import { useEffect, useState } from 'react';
import './style.css';

interface FrameRateIndicatorProps {
  videoTrack: any;
}

const FrameRateIndicator = ({ videoTrack }: FrameRateIndicatorProps) => {
  const [frameRate, setFrameRate] = useState<number | null>(null);

  useEffect(() => {
    if (!videoTrack) {
      setFrameRate(null);
      return;
    }

    const updateFrameRate = () => {
      const settings = videoTrack?.track?.getSettings?.();
      if (settings?.frameRate) {
        setFrameRate(Math.round(settings.frameRate));
      }
    };

    updateFrameRate();
    const interval = setInterval(updateFrameRate, 1000);

    return () => clearInterval(interval);
  }, [videoTrack]);

  if (frameRate === null) {
    return null;
  }

  return (
    <span className="cometchat-calls-frame-rate-indicator">
      {frameRate} fps
    </span>
  );
};

export default FrameRateIndicator;
